import { render, staticRenderFns } from "./Reattribution.vue?vue&type=template&id=33645585"
import script from "./Reattribution.vue?vue&type=script&lang=js"
export * from "./Reattribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports